var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('v-message',{attrs:{"type":_vm.message.type,"message":_vm.message.text,"small":""}}):_c('div',{staticClass:"message-skeleton w-full h-16 bg-neutral-10 rounded-lg animate-pulse"})}
var staticRenderFns = []

export { render, staticRenderFns }